const REVISION_DATE_FORMAT = new Intl.DateTimeFormat(undefined, { dateStyle: "medium", timeStyle: "short" });

const revisionRecordOf = (node: ChildNode): Element | null => {
  if (!(node instanceof Element)) return null;
  if (node.getAttribute("w:date") !== null || node.getAttribute("w:author") !== null) return node;
  return node.getElementsByTagName("w:ins")[0] ?? node.getElementsByTagName("w:del")[0] ?? null;
};

export function friendlyRevisionDate(isoDate: string): string {
  const parsed = new Date(isoDate);
  return Number.isNaN(parsed.getTime()) ? "" : REVISION_DATE_FORMAT.format(parsed);
}

export function revisionTitleOf(node: ChildNode): string {
  const record = revisionRecordOf(node);
  const author = record?.getAttribute("w:author") ?? "";
  const date = friendlyRevisionDate(record?.getAttribute("w:date") ?? "");
  return [author, date].filter((part) => part.length > 0).join(" · ");
}
